import { render, staticRenderFns } from "./regFormTrainee.vue?vue&type=template&id=fb0aa824&scoped=true"
import script from "./regFormTrainee.vue?vue&type=script&lang=js"
export * from "./regFormTrainee.vue?vue&type=script&lang=js"
import style0 from "./regFormTrainee.vue?vue&type=style&index=0&id=fb0aa824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0aa824",
  null
  
)

export default component.exports